const STATE_PROP = Symbol("STATE_PROP");
const STORES_PROP = Symbol("STORES_PROP");
const QUEUE_PROP = Symbol("QUEUE_PROP");
const POS_PROP = Symbol("POS_PROP");
const ACTION_QUEUE_PROP = Symbol("ACTION_QUEUE_PROP");
const REVISION_NAMES_PROP = Symbol("REVISION_NAMES_PROP");
const REVISION_QUEUE_PROP = Symbol("REVISION_QUEUE_PROP");
const REVISION_INDEX_PROP = Symbol("REVISION_INDEX_PROP");
const CURRENT_REV_ID_PROP = Symbol("CURRENT_REV_ID_PROP");
const TRANSACTION_PROP = Symbol("TRANSACTION_PROP");
const TRANSACTION_TIMER_PROP = Symbol("TRANSACTION_TIMER_PROP");
const AUTO_RECORD_PROP = Symbol("AUTO_RECORD_PROP");
const IS_APPLYING_STASH = Symbol("IS_APPLYING_STASH");
const PROPS = Object.freeze([
  STATE_PROP,
  STORES_PROP,
  QUEUE_PROP,
  POS_PROP,
  ACTION_QUEUE_PROP,
  REVISION_NAMES_PROP,
  REVISION_QUEUE_PROP,
  REVISION_INDEX_PROP,
  CURRENT_REV_ID_PROP,
  TRANSACTION_PROP,
  TRANSACTION_TIMER_PROP,
  AUTO_RECORD_PROP,
  IS_APPLYING_STASH
]);
export {
  ACTION_QUEUE_PROP,
  AUTO_RECORD_PROP,
  CURRENT_REV_ID_PROP,
  IS_APPLYING_STASH,
  POS_PROP,
  PROPS,
  QUEUE_PROP,
  REVISION_INDEX_PROP,
  REVISION_NAMES_PROP,
  REVISION_QUEUE_PROP,
  STATE_PROP,
  STORES_PROP,
  TRANSACTION_PROP,
  TRANSACTION_TIMER_PROP
};
